import React, {useState} from "react";
import {formatValueAsDateAndTime} from "../../../../../helpers/utils/DateUtils";
import {DataTableColumn} from "../../../../../components/common/datatable/DataTableTypes";
import ButtonTray from "../../../../../components/common/form/ButtonTray";
import {DataTable} from "../../../../../components/common/datatable/DataTable";
import {useGetAllAssignToMembersQuery} from "../../../../user/teams/teamsApi";
import Modal from "../../../../../components/common/form/Modal";
import {handleRTKQuery} from "../../../../../helpers/utils/RtkQueryUtils";
import {useAssignProductMutation} from "../../../productsApi";
import InputField from "../../../../../components/common/form/InputField";
import {FaSearch} from "react-icons/fa";
import {SearchInputWrapper} from "../../../../../components/common/datatable/filter/SearchInputWrapper";


interface AssignToFormProps {
    show: boolean;
    setShow: (show: boolean) => void;
    productId: any;
    isHoa?: boolean;
    tenant: string;
}

const AssignToForm: React.FC<AssignToFormProps> = ({
                                                       show,
                                                       setShow,
                                                       productId,
                                                       isHoa,
                                                       tenant
                                                   }) => {

    const [selectedId, setSelectedId] = useState<any>(null);
    const [updateAssignmentInfoApi, updateAssignmentInfoApiResponse] = useAssignProductMutation();
    const [name, setName] = useState("");
    const iconButtonStyle = "fa cursor-pointer text-surface-3 absolute left-auto right-5 top-[18px]";

    const handleSubmit = async () => {

        if (selectedId) {
            await handleRTKQuery(() => {
                updateAssignmentInfoApi({productId: productId, userId: selectedId, isAssigned: "false"});
            }, () => {
                setShow(false);
            });
        }
    }
    const handleRowSelection = (newSelectedRow: any, row: any) => {
        setSelectedId(row?.original?.id);
    };

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "username",
            overrideSortColumn: "u.username",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter username..."}
                                                     accessor={"username"} />,
                overrideFilterLabel: "Username",
                overrideFilterAccessor: "searchParamUserName"
            }]
        },
        {
            label: "Email",
            accessor: "u.email",
            cell: (props: any) => <span>{props.row.original.email}</span>
        },
        {
            label: "Last Logged On",
            accessor: "u.lastLoginDate",
            cell: (props: any) => formatValueAsDateAndTime(props.row.original.lastLoginDate)
        },
        {
            label: "Queue Size",
            accessor: "productQueueSize",
            canSort: false
        }
    ]

    return (

        <Modal
            title={"Assign Product to User"}
            show={show}
            setShow={setShow}
            hoa={isHoa}
            className="w-2/4 bg-text-0 rounded-lg shadow-lg"
            fields={
                <>
                    <div className="modal-body max-h-[calc(100vh-200px)] overflow-auto [-ms-overflow-style:none] [scrollbar-width:none]">
                        <DataTable
                            columns={columns}
                            actions={{
                                fetchAction: useGetAllAssignToMembersQuery,
                            }}
                            defaultFilter={{
                                pageNumber: 0,
                                pageSize: 8,
                                tenant: tenant,
                            }}
                            defaultSortOptions={{
                                accessor: "u.username",
                                direction: "desc"
                            }}
                            rowSelectionOptions={{
                                enableRowSelection: true,
                                onSelectionChange: handleRowSelection,
                                enableMultiRowSelection: false,
                                rowIdAccessor: 'id'
                            }}
                            classname={`${isHoa ? 'bg-highlight-1 text-text-0' : 'bg-highlight-5 text-text-0 border-highlight-0'
                            }`}
                            defaultFilterFormExpanded={true}
                            renderOptions={{skipUserSettingRender: true, skipFilterButtonRender: true, skipButtonSectionRender: true}}
                            appendFilterToUrl={false}
                        />
                        <div className={'mt-4 border-t border-t-surface-5 flex justify-end'}>
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () => setShow(false),
                                            type: "cancel",
                                        },
                                        buttonType: "button",
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Assign",
                                            type: "submit",
                                            onClick: handleSubmit,
                                            isHoa: isHoa,
                                            isLoading: updateAssignmentInfoApiResponse?.isLoading
                                        },
                                        buttonType: "button",
                                    }

                                ]}
                                align="end"
                                gap={2}
                            />
                        </div>


                    </div>
                </>
            }
        />

    );
};

export default AssignToForm;